import attachFilesForSelectedAction from './helpers/attachFilesForSelectedAction';
import createFilePickerUserConfiguration from './helpers/configuration/createFilePickerUserConfiguration';
import { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import { FilePickerConfiguration, FilePickerResult, lazyFilePicker } from 'owa-filepicker';
import { trace } from 'owa-trace';

export default async function attachmentFilePicker(
    createAttachmentHandler: CreateAttachmentHandler,
    filePickerConfiguration: FilePickerConfiguration
) {
    const filePicker = await lazyFilePicker.import();
    if (!filePickerConfiguration.userConfiguration) {
        filePickerConfiguration.userConfiguration = createFilePickerUserConfiguration();
    }

    try {
        return filePicker(filePickerConfiguration)
            .then((result: FilePickerResult) => {
                attachFilesForSelectedAction(
                    createAttachmentHandler,
                    result.files,
                    result.source,
                    result.action
                );
            })
            .catch(() => {
                // No files were selected
            });
    } catch (error) {
        trace.error(
            'Error creating the file picker. Attaching or sharing files might not work! ' + error
        );
    }
}
